"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var ArrowRightRounded = function ArrowRightRounded(props) {
  return _react["default"].createElement("svg", (0, _extends2["default"])({}, props, {
    viewBox: "0 0 18 29",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }), _react["default"].createElement("title", null, props["aria-label"]), _react["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    transform: "translate(9.024418, 14.285714) rotate(-360.000000) translate(-9.024418, -14.285714)",
    d: "M0.738857321,4.2743665 C-0.241098176,3.30171419 -0.247018582,1.71881282 0.725633723,0.738857321 C1.69828603,-0.241098176 3.2811874,-0.247018582 4.2611429,0.725633723 L18.0488368,14.4105738 L4.51266154,27.8457997 C3.53270351,28.8184494 1.94980215,28.8125249 0.977152403,27.8325668 C0.00450265508,26.8526088 0.0104271921,25.2697074 0.990385226,24.2970577 L10.9511634,14.4105646 L0.738857321,4.2743665 Z"
  })));
};

ArrowRightRounded.defaultProps = {
  width: "18px",
  height: "29px",
  "aria-label": "Right Arrow",
  color: "#002272"
};
var _default = ArrowRightRounded;
exports["default"] = _default;